<template>
  <div class="setting">
    <el-form :model="user" :rules="rules" ref="ruleForm" class="form-line_box">
      <el-form-item prop="old_password">
        <el-input
          v-model="user.old_password"
          placeholder="请输入原始密码"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="user.password"
          placeholder="请输入新密码"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item prop="passwords">
        <el-input
          v-model="user.passwords"
          placeholder="请确认新密码"
          type="password"
          show-password
        ></el-input>
      </el-form-item>

      <el-form-item class="form-btns">
        <el-button type="primary" @click="submitForm('ruleForm')"> 确认修改 </el-button>
      </el-form-item>

      <el-form-item>
        <p class="form-remark">忘记密码，请联系中知在线管理员</p>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { modifypassword } from "@/api/user.js";
import * as auth from "@/utils/auth.js";
export default {
  name: "My",
  props: {},
  data() {
    var oldvalidatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原密码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!/^(\w){6,20}$/.test(value)) {
        callback(new Error("密码最少6位"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.user.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      user: {
        old_password: "",
        password: "",
        passwords: ""
      },
      rules: {
        old_password: [{ validator: oldvalidatePass, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        passwords: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            await modifypassword(this.user);
            this.$message({
              message: "密码修改成功，请重新登录",
              type: "success"
            });
            await this.$delay(800);
            this.$store.dispatch("user/resetToken").then(() => {
              this.$router.push("login");
            });
          } catch (error) {}
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.setting {
  width: 340px;
  margin: 100px auto 0;
}
</style>
